import $ from "jquery";


class Popup {
   constructor(){

      // Checking if cookie exists is completed in controller not on frontend so here we check for existance instead
      var popup = document.getElementById("popupForm");

      if(popup){
         // Wait 4 seconds before showing popup
         setTimeout(function popupTimer(){
            popup.classList.add("is-active");
         }, 4000);
      }

      // Setup doc clicks for closing popups
      $(document).click(function popupCloseCheck(e){
         if(e.target.hasAttribute("data-popup-close")){
            $(".cta-popup").removeClass("is-active");

            // Set cookie to expire for just the session
            document.cookie = "noPopup=1";
         }
      });
        
      
      
   }
}


$(document).ready(function(){
   new Popup();
});


// WEBPACK FOOTER //
// ./scripts/popup.js